import { type EnterpriseSettings, SettingType } from '@/types'

/**
 * The value to report for a `SettingChanged` event, or undefined when the patch carries nothing
 * safe — or nothing at all — to report.
 *
 * `null` counts. Restore default on the chat disclosure patches `null` to clear the org's custom
 * notice so each member gets it in their own language again, and `typeof null === 'object'`, so a
 * `boolean`-or-`string` gate dropped that event entirely.
 *
 * The notice TEXT never leaves the portal: only whether the org has a custom one.
 */
export const trackedSettingValue = (key: keyof EnterpriseSettings, value: unknown): boolean | string | undefined => {
  if (typeof value === 'boolean') return value
  if (key === SettingType.notetakerConsentChatMessage) {
    if (value === null) return 'default'
    // An empty string cannot arrive: Save is disabled while the draft trims to nothing.
    return typeof value === 'string' ? 'custom' : undefined
  }
  return typeof value === 'string' ? value : undefined
}
